export default {"src":"/_next/static/media/logoHeaderMobile.623b84a9.svg","height":34,"width":34};